import { Sports, WORLD_REGIONS_CODES } from '@gin-betting/constants';
import core, { App } from '@gin-betting/core';
import { keys } from 'lodash';

import { Product } from 'app-constants';
import { TimeInterval, TimeIntervalBoundary } from './types';

const {
    constants: { SportType },
} = core;

export const FILTER_TIME_PERIODS: App.TimePeriodVariants[] = [
    App.TimePeriodVariants.ONE_HOUR,
    App.TimePeriodVariants.TODAY,
    App.TimePeriodVariants.YESTERDAY,
    App.TimePeriodVariants.THREE_DAYS,
    App.TimePeriodVariants.WEEK,
];

export const INTERVAL_ALL = 0;

export const TIME_INTERVAL_ALL: TimeInterval = {
    interval: INTERVAL_ALL,
    displayedValue: INTERVAL_ALL,
    unit: 'minute',
};

export const customFlagsMapping = {
    ENG: 'GB',
    EU: 'EU',
};

export const ACTIVE_COUNTRY_KEY_DIVIDER = '~' as const;

export const DEFAULT_TIME_PERIOD = App.TimePeriodVariants.YESTERDAY;

export const TIME_FILTER_NEXT_TO_GO_BOUNDARY: TimeIntervalBoundary = {
    filteringKey: 'dateTo',
    interval: 1,
    unit: 'day',
};

export const UNGROUPED_CATEGORIES_KEY = 'other' as const;

const STATIC_SPORTS_ALL = [
    Sports.ESPORTS_COUNTER_STRIKE,
    Sports.ESPORTS_DOTA_2,
    Sports.FOOTBALL,
    Sports.BASKETBALL,
    Sports.TENNIS,
    Sports.ICE_HOCKEY,
    Sports.TABLE_TENNIS,
    Sports.ESPORTS_LEAGUE_OF_LEGENDS,
    Sports.ESPORTS_BASKETBALL,
    Sports.ESPORTS_FIFA,
    Sports.ESPORTS_VALORANT,
    Sports.ESPORTS_FORTNITE,
] as const;

const STATIC_SPORTS_ESPORT = [
    Sports.ESPORTS_COUNTER_STRIKE,
    Sports.ESPORTS_DOTA_2,
    Sports.ESPORTS_FIFA,
    Sports.ESPORTS_LEAGUE_OF_LEGENDS,
    Sports.ESPORTS_FORTNITE,
] as const;

const STATIC_SPORTS_CLASSIC = [
    Sports.FOOTBALL,
    Sports.BASKETBALL,
    Sports.TENNIS,
    Sports.ICE_HOCKEY,
    Sports.VOLLEYBALL,
    Sports.TABLE_TENNIS,
    Sports.HANDBALL,
] as const;

export const CATEGORIZER_STATIC_SPORTS_BY_TYPE: Record<
    App.SportType,
    readonly string[]
> = {
    [SportType.Mix]: STATIC_SPORTS_ALL,
    [SportType.Esport]: STATIC_SPORTS_ESPORT,
    [SportType.Classic]: STATIC_SPORTS_CLASSIC,
};

export const EXCLUDED_WORLD_REGIONS = ['GB-ENG', 'GB-SCT', 'GB-WLS', 'GB-NIR'];

export const WORLD_REGIONS = keys(WORLD_REGIONS_CODES).filter(
    code => !EXCLUDED_WORLD_REGIONS.includes(code)
);

export const ALL = 'all' as const;

export const ORDER_CATEGORIZER_ITEMS_MAPPING = {
    [Sports.FOOTBALL]: {
        [Product.ru]: ['RU', 'GB-ENG', 'ES', 'DE', 'IT', 'FR'],
        [Product.bet]: ['GB-ENG', 'ES', 'DE', 'IT', 'FR', 'RU', 'UA'],
        [Product.com]: ['GB-ENG', 'ES', 'DE', 'IT', 'FR', 'RU', 'UA'],
        [Product.ua]: ['UA', 'GB-ENG', 'ES', 'DE', 'IT', 'FR', 'RU'],
    },
    [Sports.BASKETBALL]: {
        [Product.ru]: ['RU', 'US', 'ES', 'PH', 'CN', 'DE', 'IT', 'FR'],
        [Product.bet]: ['US', 'CN', 'RU', 'ES', 'DE', 'IT', 'FR', 'PH', 'UA'],
        [Product.com]: ['US', 'CN', 'RU', 'ES', 'DE', 'IT', 'FR', 'PH', 'UA'],
        [Product.ua]: ['UA', 'US', 'ES', 'PH', 'CN', 'DE', 'IT', 'FR', 'RU'],
    },
    [Sports.ICE_HOCKEY]: {
        [Product.ru]: ['RU', 'US', 'BY', 'KZ', 'FI', 'SE', 'CH', 'UA'],
        [Product.bet]: ['US', 'RU', 'FI', 'SE', 'CH', 'BY', 'KZ', 'UA'],
        [Product.com]: ['US', 'RU', 'FI', 'SE', 'CH', 'BY', 'KZ', 'UA'],
        [Product.ua]: ['US', 'UA', 'RU', 'BY', 'KZ', 'FI', 'SE', 'CH'],
    },
    [Sports.VOLLEYBALL]: {
        [Product.ru]: ['RU', 'BY', 'KZ', 'US', 'PL', 'ES', 'IT', 'TR'],
        [Product.bet]: ['US', 'ES', 'IT', 'TR', 'PL', 'RU'],
        [Product.com]: ['US', 'ES', 'IT', 'TR', 'PL', 'RU'],
        [Product.ua]: ['UA', 'US', 'RU', 'BY', 'KZ', 'PL', 'ES', 'IT', 'TR'],
    },
    [Sports.TABLE_TENNIS]: {
        [Product.ru]: ['RU', 'UA'],
        [Product.bet]: ['RU', 'UA'],
        [Product.com]: ['RU', 'UA'],
        [Product.ua]: ['UA', 'RU'],
    },
    [Sports.HANDBALL]: {
        [Product.ru]: ['RU', 'HU', 'DE', 'DK', 'ES', 'FR', 'NO', 'PL'],
        [Product.bet]: ['DE', 'ES', 'FR', 'DK', 'RU', 'NO', 'HU', 'PL', 'UA'],
        [Product.com]: ['DE', 'ES', 'FR', 'DK', 'RU', 'NO', 'HU', 'PL', 'UA'],
        [Product.ua]: ['UA', 'DE', 'ES', 'FR', 'DK', 'RU', 'NO', 'HU', 'PL'],
    },
};

export const SPORTS_ORGANIZATION = ['tennis'];

export enum CategorizerRowType {
    Subgroup = 'subgroup',
    Tournament = 'tournament',
}

export enum OverlayType {
    NONE = 'NONE',
    TOURNAMENT_LIST = 'TOURNAMENT_LIST',
    FEATURED_TOURNAMENTS_LIST = 'FEATURED_TOURNAMENTS_LIST',
}
